export default __webpack_public_path__ + "static/impact3-5de0e702e87535320e601a7f0971789e.png";